import React, { useEffect, useId } from "react";

// Modal used by both post studios. Escape and backdrop clicks close it unless busy.
const StudioDialog = ({ eyebrow, title, onClose, busy = false, role = "dialog", wide = false, children, actions }) => {
  const titleId = useId();
  useEffect(() => {
    const onKeyDown = (event) => { if (event.key === "Escape" && !busy) onClose(); };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [busy, onClose]);

  return <div className="studio-backdrop" onMouseDown={(event) => { if (event.target === event.currentTarget && !busy) onClose(); }}>
    <section className={`studio-dialog${wide ? " is-wide" : ""}`} role={role} aria-modal="true" aria-labelledby={titleId}>
      <header className="studio-dialog-head">
        <div>{eyebrow && <p className="studio-eyebrow">{eyebrow}</p>}<h2 id={titleId}>{title}</h2></div>
        <button type="button" className="studio-icon-button" aria-label="Close" onClick={onClose} disabled={busy}><i className="ti ti-x" aria-hidden="true" /></button>
      </header>
      <div className="studio-dialog-body">{children}</div>
      {actions && <footer className="studio-dialog-actions">{actions}</footer>}
    </section>
  </div>;
};

export default StudioDialog;
